import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  Alert,
} from '@mui/material';
import {
  Download as DownloadIcon,
  Lock as LockIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import compFile from '../assets/Web_EIP_CompGuide_April.xlsx';

const Compensation = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ py: 2 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        {t('compensation.title', 'Compensation')}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
        {t('compensation.subtitle', 'Commission grids and compensation details.')}
      </Typography>

      <Alert
        severity="warning"
        icon={<LockIcon />}
        sx={{ mb: 3, borderRadius: 2 }}
      >
        <Typography variant="body2">
          {t('compensation.confidential', 'CONFIDENTIAL — For internal use only. This compensation information is for current EIP agents. This is not a recruiting tool and not carrier issued. Do not share outside of the organization.')}
        </Typography>
      </Alert>

      <Paper sx={{ p: { xs: 4, md: 6 }, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <DownloadIcon sx={{ fontSize: 64, color: '#2C9C6C' }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          {t('compensation.downloadTitle', 'EIP Compensation Guide')}
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3, maxWidth: 480, mx: 'auto' }}>
          {t('compensation.downloadText', 'Download the full compensation guide with commission grids for all carriers.')}
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<DownloadIcon />}
          href={compFile}
          download="EIP Compensation Guide.xlsx"
          sx={{ fontWeight: 600 }}
        >
          {t('compensation.downloadButton', 'Download Compensation Guide')}
        </Button>
      </Paper>
    </Container>
  );
};

export default Compensation;
